import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/core-plugin-api/alpha';
import { coreComponentsTranslationRef } from '@backstage/core-components';
import { TranslationBlueprint } from '@backstage/plugin-app-react';

const coreComponentsTranslationsMessagesOverride = createTranslationMessages({
  ref: coreComponentsTranslationRef,
  full: false,
  messages: {
    'oauthRequestDialog.title': 'Login required',
  },
});

const coreComponentsTranslationsOverride = createTranslationResource({
  ref: coreComponentsTranslationRef,
  translations: {
    en: async () => ({
      default: coreComponentsTranslationsMessagesOverride,
    }),
  },
});

export const coreComponentsTranslationsOverrideExtension =
  TranslationBlueprint.make({
    name: 'core-components-translations-override',
    params: {
      resource: coreComponentsTranslationsOverride,
    },
  });
